import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DmsRepositoryService } from './services/dms-repository.service';
import { MetaService } from '@shared/services/meta/meta.service';

@Component({
  selector: 'app-dms',
  templateUrl: './dms.component.html',
  providers: [DmsRepositoryService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DmsComponent implements OnInit {
  constructor(
    private metaService: MetaService,
    public repository: DmsRepositoryService
  ) {}

  logosVisibleMobile = 8;

  ngOnInit(): void {
    this.metaService.title(this.repository.title);
  }

  get hasHiddenLogos(): boolean {
    return this.repository.listCompanies.length > this.logosVisibleMobile;
  }

  showMore(): void {
    this.logosVisibleMobile += 8;
  }
}
